export default "__VITE_ASSET__YWnMiLyo__"